import React, { useState } from "react";
import { Box, TextField, Typography, MenuItem, Button } from "@mui/material";
import { keyframes } from "@mui/system";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const Contact = () => {
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState(false);

    const handleEmailChange = (event) => {
        const value = event.target.value;
        setEmail(value);
        setEmailError(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value));
    };

    return (
        <Box sx={{
            marginTop: "20px",
            padding: "100px",
            animation: `${fadeIn} 0.5s ease-in`
        }}>
            <Box sx={{ maxWidth: "600px", margin: "auto", textAlign: "center" }}>
                <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ fontSize: "20px" }}>
                    聯繫表單
                </Typography>
                <Box
                    component="form"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "10px",
                        gap: 3,
                        padding: "40px",
                        border: "1px solid #ccc", // Border applied here
                    }}
                >
                    {/* Name Field */}
                    <TextField label="稱呼" variant="outlined" fullWidth required slotProps={{
                        inputLabel: { sx: { fontSize: "14px" } } // Title font size
                    }} sx={{ "& .MuiInputBase-input": { fontSize: "14px" } }} />

                    {/* Email Field */}
                    <TextField
                        label="信箱"
                        variant="outlined"
                        fullWidth
                        required
                        sx={{ fontFamily: "'Poppins', sans-serif", "& .MuiInputBase-input": { fontSize: "14px" } }}
                        value={email}
                        onChange={handleEmailChange}
                        error={emailError}
                        helperText={emailError ? "信箱格式錯誤" : ""}
                        slotProps={{
                            inputLabel: { sx: { fontSize: "14px" } } // Title font size
                        }}
                    />

                    {/* Reason for Contact */}
                    <TextField
                        select
                        label="主旨"
                        variant="outlined"
                        fullWidth
                        defaultValue=""
                        required
                        sx={{ fontFamily: "'Poppins', sans-serif", "& .MuiInputBase-input": { fontSize: "14px" } }}
                        slotProps={{
                            inputLabel: { sx: { fontSize: "14px" } } // Title font size
                        }}
                    >
                        <MenuItem value="main_sign" sx={{ fontSize: "14px" }}>主視覺設計</MenuItem>
                        <MenuItem value="card_design" sx={{ fontSize: "14px" }}>名片設計</MenuItem>
                        <MenuItem value="publicity_design" sx={{ fontSize: "14px" }}>文宣設計</MenuItem>
                        <MenuItem value="cooperation" sx={{ fontSize: "14px" }}>合作邀約</MenuItem>
                        <MenuItem value="other" sx={{ fontSize: "14px" }}>其他</MenuItem>
                    </TextField>

                    {/* Content Field */}
                    <TextField
                        label="內容"
                        variant="outlined"
                        fullWidth
                        required
                        sx={{ fontFamily: "'Poppins', sans-serif", "& .MuiInputBase-input": { fontSize: "14px" } }}
                        multiline
                        rows={8}
                        slotProps={{
                            inputLabel: { sx: { fontSize: "14px" } } // Title font size
                        }}
                    />
                </Box>

                {/* Submit Button */}
                <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="medium"

                        sx={{
                            fontFamily: "'Poppins', sans-serif",
                            px: 3, // Adjusts horizontal padding
                            py: 1, // Adjusts vertical padding
                            minWidth: "auto", // Prevents button from stretching
                            textTransform: "none",
                            backgroundColor: "rgb(182, 163, 93)",
                            color: "white",
                            transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease",
                            "&:hover": {
                                backgroundColor: "rgb(150, 130, 75)",
                                boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.2)",
                                transform: "scale(1.05)",
                            },
                        }}
                    >
                        送出
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default Contact;
